<template>

    <ui-view class="view-lots">

        <ui-heading title="Percelen" icon="magicon-resize-plus-3">
            <ui-button
                color="positive"
                icon="magicon-plus"
                route="parcel-add"
                v-if="$can('MUTATE_PARCELS')">Perceel toevoegen</ui-button>
            <ui-searchbar v-model="search"/>
        </ui-heading>

        <ui-table-panel
            clickable
            v-spinner="loading"
            :placeholder="parcels && !parcels.items.length"
            :total="$safe('parcels.totalCount')"
            :visible="paging.limit"
            @page="switchPage">
            <ui-table-header>
                <ui-th weight="2" field="parcelLocationId" v-model="sort">Naam</ui-th>
                <ui-th weight="2">Perceelnummer</ui-th>
                <ui-th weight="2" field="alias" v-model="sort">Alias</ui-th>
                <ui-th weight="2">Perceelvakken</ui-th>
                <ui-th weight="2">Oppervlakte</ui-th>
                <ui-th weight="1"/>
            </ui-table-header>
            <ui-tr v-for="parcel in $safe('parcels.items')" :key="parcel.id" click="edit">
                <td>{{ $safe(parcel, 'parcelLocation.name') | empty }}</td>
                <td>{{ $safe(parcel, 'parcelLocation.number') | empty }}</td>
                <td>{{ parcel.alias | empty }}</td>
                <td>{{ $safe(parcel, 'sections.itemCount') | empty }}</td>
                <td>{{ parcel.size | number }} ha</td>
                <td class="actions" @click.stop>
                    <ui-link
                        v-if="$can('MUTATE_PARCELS')"
                        icon="magicon-edit"
                        v-tooltip="'Wijzigen'"
                        action="edit"
                        :to="{ name: 'parcel-edit', params: { id: parcel.id }}" />
                    <ui-link
                        v-if="$can('MUTATE_PARCELS')"
                        icon="magicon-trash"
                        v-tooltip="'Verwijderen'"
                        @click="deleteParcel(parcel.id)" />
                </td>
            </ui-tr>
        </ui-table-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import pagingMixin from 'js-core/js/mixins/paging';
import createQuery from 'js-core/js/apollo/queries/createQuery';

import AllParcelsQuery from 'gql/queries/Parcels/AllParcels.gql';

import ParcelMutations from 'app/mutations/ParcelMutations';

@Component({

    name: 'Parcels',
    mixins: [pagingMixin],
    apollo: {
        parcels: createQuery(AllParcelsQuery, {

            variables(){

                return {
                    offset: this.paging.offset,
                    limit: this.paging.limit,
                    search: this.search,
                    sortField: this.sort.field,
                    sortDirection: this.sort.direction
                };
            }
        })
    }
})
export default class Parcels extends Vue
{
    loading = 0;

    search = this.$persist('search');
    sort = this.$persist('sort', {
        field: 'alias',
        direction: 'ASC'
    });

    breadcrumb(){

        return 'Percelen';
    }

    async deleteParcel(id) {

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je dit perceel wilt verwijderen?', true, {
            subtitle: 'Ook alle bijbehorende vakken en voorgaande acties zullen worden verwijderd!'
        });

        if(!result) {
            return;
        }

        try {

            await ParcelMutations.delete(id);

            this.$toast.success('Het perceel is succesvol verwijderd');
            this.$refetchQuery('parcels');
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting parcel ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van het perceel');
        }

        this.$overlay.close(overlay);
    }
}

</script>